<template>
  <transition-group name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
    <slot />
  </transition-group>
</template>
<script>
export default {
  name: 'ExpandTransition',
  methods: {
    enter(element) {
      const { width } = getComputedStyle(element)

      element.style.width = width
      element.style.position = 'absolute'
      element.style.visibility = 'hidden'
      element.style.height = 'auto'
      // element.style.marginTop = marginTop
      // element.style.marginBottom = marginBottom

      const { height } = getComputedStyle(element)
      const { marginTop } = getComputedStyle(element)
      const { marginBottom } = getComputedStyle(element)

      element.style.width = null
      element.style.position = null
      element.style.visibility = null
      element.style.height = 0

      getComputedStyle(element).height
      getComputedStyle(element).marginTop
      getComputedStyle(element).marginBottom

      requestAnimationFrame(() => {
        element.style.height = height
        element.style.marginTop = marginTop
        element.style.marginTop = marginBottom
      })
    },
    afterEnter(element) {
      // Небольшой костыль, так как при подстановке шаблона не срабатывало
      setTimeout(() => {
        element.style.height = 'auto'
      }, 100)
    },
    leave(element) {
      const { height } = getComputedStyle(element)
      const { marginTop } = getComputedStyle(element)
      const { marginBottom } = getComputedStyle(element)

      element.style.height = height
      element.style.marginTop = marginTop
      element.style.marginBottom = marginBottom

      getComputedStyle(element).height
      getComputedStyle(element).marginTop
      getComputedStyle(element).marginBottom

      requestAnimationFrame(() => {
        element.style.height = 0
        element.style.marginTop = 0
        element.style.marginBottom = 0
      })
    },
  },
}
</script>
<style scoped>
.expand-enter-active,
.expand-leave-active {
  overflow: hidden;

  transition: height 1s ease-in-out, padding 1s ease-in-out, margin 1s ease-in-out;
}

.expand-enter,
.expand-leave-to {
  height: 0;
}

* {
  will-change: height, padding, margin;

  transform: translateZ(0);

  perspective: 1000px;
  backface-visibility: hidden;
}
</style>
